import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class PcaKernalGraph extends AbstractScatterVisualization {
}
